import React, { Component } from 'react';
import UNXHeaderAlt from "../components/header_alt";
import UNXFooter from "../components/footer";
import '../style/main.css';
import '../style/home.css';
import '../style/checkout.css';
import '../style/dashboard.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faClock,
    faTimes,
    faDollarSign,
    faTv,
    faLaptop,
    faMobileAlt,
    faTabletAlt,
    faAngleDown,
    faAngleUp
} from '@fortawesome/free-solid-svg-icons';
import monstroImg from '../static/monstro_img.png';
import passportImg from '../static/ninja_passport.png';
import promoPoster from '../static/promoPoster.png';
import awgLogo from '../static/awg_logo.png';
import unaaLogo from '../static/unaa_logo.png';
import foxLogo from '../static/fox_logo.png';
import movemberLogo from '../static/movember_logo.png';
import bornPrimitive from '../static/born_prim_logo.png';


library.add(faClock, faTimes, faDollarSign, faTv, faLaptop, faMobileAlt, faTabletAlt, faAngleDown, faAngleUp);


class AboutUs extends Component {

    state = {
        openFree: false,
        openPremium: false
    }

    toggleDiv(type) {
        var divState;
        if (this.state[type] == true) {
            divState = false;
        } else {
            divState = true;
        }
        this.setState({ [type]: divState });
    }

    goTo(str) {
        this.props.history.push('/' + str);
    }


    componentDidMount() {
        console.log(this);
    }

    render() {
        return (
            <div className="homeDiv">
                <UNXHeaderAlt title='' link='' linkTitle=''></UNXHeaderAlt>
                <div id="aboutUsImg">
                    <div style={{
                        position: "absolute",
                        bottom: "0px",
                        fontFamily: "VIPESSRG",
                        fontSize: "2em",
                        color: "rgb(57,177,211)",
                        width: "100%",
                        textAlign: "center",
                        padding: "10px"
                    }}>About Us
                    </div>
                </div>
                <div className="pageContainer">

                    {/* DISTRIBUTION ON WHISTLE TV */}
                    <div style={{
                        marginTop: "25px",
                        fontFamily: "VIPESSRG",
                        fontSize: "2em",
                        color: "rgb(20,24,32)"
                    }}>Distribution on Whistle TV
                    </div>
                    <div className="whiteCard" style={{ borderBottom: "3px solid rgb(57,177,211)" }}>
                        <div className="whiteCardContainer">
                            <div className="whiteCardText" style={{ fontSize: "1em" }}>
                                <div style={{
                                    textAlign: 'center',
                                    fontSize: '0.8em'
                                }}>
                                    <div style={{
                                        fontWeight: 'bold',
                                        fontSize: '1.2em'
                                    }}>UNX TO AIR ON WHISTLE TV</div>

                                    <div style={{
                                        fontStyle: 'italic',
                                        paddingTop: '10px'
                                    }}>Whistle TV, one of the fastest growing OTT and VOD sports and entertainment networks will include the inaugural ninja sporting season in their upcoming programming.</div>
                                    <br/>

                                    <div style={{
                                        fontStyle: 'italic',
                                        paddingTop: '5px'
                                    }}>Season I will feature twelve open qualifying competitions and tri-finals culminating with a Championship event.&nbsp;</div><br/>

                                    <div style={{textAlign: 'left'}}><div style={{paddingTop: '15px'}}><strong>Chicago, Ill. (August 28, 2020) –</strong> UNX, the first professional ninja sporting league, is excited to announce that Season I will soon be available on Whistle TV. Earlier this summer, UNX and Team Whistle signed a deal in which all Open-Qualifier and Major competitions will be available on platforms through which Whistle TV is distributed, includingSamsung TV Plus, Plex TV, Stirr, Vizio, and Distro TV.</div>&nbsp;<div style={{paddingTop: '15px'}}>Whistle TV is an OTT Linear and VOD sports and entertainment network featuring Whistle original shows and premium library content from studios, networks and leagues across the industry, filling a void in the market by combining brand safe sports, entertainment and lifestyle content. Whistle TV offers ad-supported content around the clock focusing on original shows, episodic series featuring popular influences and niche sports programming in addition to inspirational movies and documentaries with viewership reaching approximately 51 million households.&nbsp;</div><div style={{paddingTop: '15px'}}>“UNX athletes take an elite sport and make it entertaining to the masses through their content,” said Griffin Gmelich, EVP of OTT and Content at Team Whistle. “Our audiences crave positive, uplifting sports content, and as the exclusive distribution partner of UNX, we’re excited to introduce them to the sport across our Whistle TV platform.”&nbsp;</div><div style={{paddingTop: '15px'}}>UNX Competitions focus on the sport of ninja featuring innovative courses designed by different gym owners around the country. Both familiar faces and brand-new names as young as 13 years old compete to prove their athletic capabilities and consistencies in this never before seen season-long format. UNX joins additional programming on Whistle TV including original series No Days Off, My Hustle and Bad Jokes, and niche leagues like Glory Kickboxing and World Arm Wrestling.&nbsp;</div><div style={{paddingTop: '15px'}}>“It’s amazing to see how much the sport of ninja has grown across the world and all the fans who support these athletes and we are excited about creating a professional sport for all the young ninjas who are training at ninja gyms or on playgrounds to one day become professional ninjas,” stated Chris DiGangi - UNX CEO. </div><div style={{paddingTop: '15px'}}>New episodes of UNX will premiere exclusively on Whistle TV on Monday evenings, with re-airings on Wednesdays and Fridays. For more information on UNX, please visit unxnow.com.&nbsp;</div><div style={{paddingTop: '15px'}}>ABOUT TEAM WHISTLE Team Whistle – comprising Whistle, New Form, Tiny Horse and Vertical Networks – is a global media company that’s changing the sports and entertainment game. We create and distribute engaging content experiences for today’s audiences, always playing in the positive and resonating with what’s relatable. Our premium scripted, unscripted and interactive shows, podcasts, music and merchandise are available on the social, audio and streaming platforms that matter most. For brands, sports leagues and media companies, we help them activate and engage consumers across the content ecosystem. To learn more, visit https://teamwhistle.com/.&nbsp;</div><div style={{paddingTop: '15px'}}>ABOUT UNX UNX is the premier professional league for the sport of ninja created by ninja athletes. We highlight the talent and dedication of our athletes on creative courses designed by gym owners throughout the United States. For more information, visit www.unxnow.com. </div></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* OUR MISSION */}
                    <div style={{
                        marginTop: "25px",
                        fontFamily: "VIPESSRG",
                        fontSize: "2em",
                        color: "rgb(20,24,32)"
                    }}>Our Mission
                    </div>
                    <div className="whiteCard" style={{ borderBottom: "3px solid rgb(57,177,211)" }}>
                        <div className="whiteCardContainer">
                            <div className="whiteCardText" style={{ fontSize: "1em" }}>UNX is the home for everything
                                ninja. With a focus on making the sport of ninja accessible to everyone, we offer live
                                streamed and on demand competitions, athlete interviews, training tips, and much more.
                                Created by ninjas, UNX is committed to elevating the sport of ninja to a professional
                                level enjoyed by all.
                            </div>
                        </div>
                    </div>

                    {/* THE TEAM */}
                    <div style={{
                        marginTop: "25px",
                        fontFamily: "VIPESSRG",
                        fontSize: "2em",
                        color: "rgb(20,24,32)"
                    }}>The Team
                    </div>
                    <div className="flex-responsive-row tabletWrap">
                        <div style={{ flex: "1", margin: "10px" }}>
                            <div className="aspect-ratio-box" style={{
                                background: "url(https://unx-now-main-storage.s3.amazonaws.com/images/unx_team/jeff_piejak.png), rgb(0,0,0)",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                borderRadius: "0px"
                            }}>
                                {/* <div className="aspect-ratio-box-inside"> */}
                                {/* <div className="flexbox-centering">
                                        <div className="viewport-sizing">
                                          <div>

                                            </div>
                                        </div>
                                        </div> */}
                                {/* </div> */}
                            </div>
                            <div style={{ backgroundColor: "rgb(255,255,255", padding: "15px", minHeight: "75px" }}>
                                <div style={{
                                    fontSize: "1.5em",
                                    color: "rgb(60,64,72)",
                                    fontWeight: "bold",
                                    fontFamily: "VIPESSRG",
                                    letterSpacing: "2px"
                                }}>Jeff Piejak
                                </div>
                                <div style={{ fontSize: "1em", color: "rgb(60,64,72)", fontWeight: "bold" }}>CEO<br/>
                                </div>
                            </div>
                        </div>

                        <div style={{ flex: "1", margin: "10px" }}>
                            <div className="aspect-ratio-box" style={{
                                background: "url(https://unx-now-main-storage.s3.amazonaws.com/images/unx_team/howard_bolter.png), rgb(0,0,0)",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                borderRadius: "0px"
                            }}>
                                {/* <div className="aspect-ratio-box-inside"> */}
                                {/* <div className="flexbox-centering">
                                        <div className="viewport-sizing">
                                          <div>

                                            </div>
                                        </div>
                                        </div> */}
                                {/* </div> */}
                            </div>
                            <div style={{ backgroundColor: "rgb(255,255,255", padding: "15px", minHeight: "75px" }}>
                                <div style={{
                                    fontSize: "1.5em",
                                    color: "rgb(60,64,72)",
                                    fontWeight: "bold",
                                    fontFamily: "VIPESSRG",
                                    letterSpacing: "2px"
                                }}>Howard Bolter
                                </div>
                                <div style={{ fontSize: "1em", color: "rgb(60,64,72)", fontWeight: "bold" }}>COO</div>
                            </div>
                        </div>

                        <div style={{ flex: "1", margin: "10px" }}>
                            <div className="aspect-ratio-box" style={{
                                background: "url(https://unx-now-main-storage.s3.amazonaws.com/images/unx_team/ethan_swanson.png), rgb(0,0,0)",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                borderRadius: "0px"
                            }}>
                                {/* <div className="aspect-ratio-box-inside"> */}
                                {/* <div className="flexbox-centering">
                                        <div className="viewport-sizing">
                                          <div>

                                            </div>
                                        </div>
                                        </div> */}
                                {/* </div> */}
                            </div>
                            <div style={{ backgroundColor: "rgb(255,255,255", padding: "15px", minHeight: "75px" }}>
                                <div style={{
                                    fontSize: "1.5em",
                                    color: "rgb(60,64,72)",
                                    fontWeight: "bold",
                                    fontFamily: "VIPESSRG",
                                    letterSpacing: "2px"
                                }}>Ethan Swanson
                                </div>
                                <div style={{ fontSize: "1em", color: "rgb(60,64,72)", fontWeight: "bold" }}>VP of
                                    Programming & the League
                                </div>
                            </div>
                        </div>

                        <div style={{ flex: "1", margin: "10px" }}>
                            <div className="aspect-ratio-box" style={{
                                background: "url(https://unx-now-main-storage.s3.amazonaws.com/images/unx_team/chris_digangi.png), rgb(0,0,0)",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                borderRadius: "0px"
                            }}>
                                {/* <div className="aspect-ratio-box-inside"> */}
                                {/* <div className="flexbox-centering">
                                        <div className="viewport-sizing">
                                          <div>

                                            </div>
                                        </div>
                                        </div> */}
                                {/* </div> */}
                            </div>
                            <div style={{ backgroundColor: "rgb(255,255,255", padding: "15px", minHeight: "75px" }}>
                                <div style={{
                                    fontSize: "1.5em",
                                    color: "rgb(60,64,72)",
                                    fontWeight: "bold",
                                    fontFamily: "VIPESSRG",
                                    letterSpacing: "2px"
                                }}>Chris DiGangi
                                </div>
                                <div style={{ fontSize: "1em", color: "rgb(60,64,72)", fontWeight: "bold" }}>VP of
                                    Technology & the League
                                </div>
                            </div>
                        </div>

                        <div style={{ flex: "1", margin: "10px" }}>
                            <div className="aspect-ratio-box" style={{
                                background: "url(https://unx-now-main-storage.s3.amazonaws.com/images/unx_team/kim_rahn.png), rgb(0,0,0)",
                                backgroundSize: "contain",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                borderRadius: "0px"
                            }}>
                                {/* <div className="aspect-ratio-box-inside"> */}
                                {/* <div className="flexbox-centering">
                                        <div className="viewport-sizing">
                                          <div>

                                            </div>
                                        </div>
                                        </div> */}
                                {/* </div> */}
                            </div>
                            <div style={{ backgroundColor: "rgb(255,255,255", padding: "15px", minHeight: "75px" }}>
                                <div style={{
                                    fontSize: "1.5em",
                                    color: "rgb(60,64,72)",
                                    fontWeight: "bold",
                                    fontFamily: "VIPESSRG",
                                    letterSpacing: "2px"
                                }}>Kim Rahn
                                </div>
                                <div style={{ fontSize: "1em", color: "rgb(60,64,72)", fontWeight: "bold" }}>VP of
                                    Strategy & Growth
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        marginTop: "25px",
                        fontFamily: "VIPESSRG",
                        fontSize: "2em",
                        color: "rgb(20,24,32)"
                    }}>Gym Affiliation
                    </div>
                    <div className="whiteCard" style={{ borderBottom: "3px solid rgb(57,177,211)", textAlign: "left" }}>
                        <div className="whiteCardContainer">
                            <div className="whiteCardText" style={{ fontSize: "1em" }}>
                                <div>
                                    <ul>
                                        <li>Unlimited number of gym-specific 1-month free subscription codes to give as
                                            a perk to birthday parties, new members, etc.
                                        </li>
                                        <li>Ability to sell and earn a commission on sales of UltiFit @ Home workout
                                            systems.
                                        </li>
                                        <li>Listing of your gym and address on the UNX website</li>
                                        <li>Ability to list up to (4) four gym events per year on the UNX calendar of
                                            events
                                        </li>
                                        <li>Complimentary UNX subscription for gym use</li>
                                        <li>15% discount on UNX sponsored “Spotted” Coaching Certification trainings
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    FAQ
                                </div>
                                <div>
                                    <ul>
                                        <li>How much does it cost to be a UNX affiliate?</li>
                                        <ul>
                                            <li>Nothing! UNX aspires to be the home of everything ninja and the one-stop
                                                shop for anyone who is looking to get more involved with the sport. As
                                                the training grounds for all future professional ninjas, we aim to have
                                                a great relationship with all ninja gyms
                                            </li>
                                        </ul>
                                        <li>Do I need to be a United States based facility?</li>
                                        <ul>
                                            <li>No! We welcome affiliates from ninja gyms worldwide!</li>
                                        </ul>
                                        <li>What are the requirements for being a UNX affiliate?</li>
                                        <ul>
                                            <li>In order to qualify as a UNX affiliate, your facility must offer ninja
                                                classes regularly on their calendar. Occasional workshops or appearances
                                                do not qualify.
                                            </li>
                                        </ul>
                                        <li>What is Spotted?</li>
                                        <ul>
                                            <li>Spotted Certification by World Ninja Sport stands for Safe Progressive
                                                Obstacle Training Techniques Education and at its core is a ninja and
                                                obstacle course coaching certification. Through the certification
                                                program, your coaches will learn how to set up a safe gym, the
                                                responsibilities of a coach, how to control a group, the different types
                                                of obstacles and how to incorporate them into a course, class structure,
                                                how to run an efficient class, spotting and more! Additionally, if your
                                                coaches have a Spotted certification, your gym may qualify for up to a
                                                20% discount from your liability insurance through Francis L.
                                                Dean &amp; Associates.
                                            </li>
                                        </ul>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{
                        marginTop: "25px",
                        fontFamily: "VIPESSRG",
                        fontSize: "2em",
                        color: "rgb(20,24,32)"
                    }}>Sponsors
                    </div>
                    <div>Thank you to our sponsors. If you are interested in a sponsorship or ad space with UNX, please
                        contact <a href="mailto:info@unxnow.com">info@unxnow.com</a></div>
                    <div className="flex-container-row"
                         style={{ justifyContent: "space-evenly", alignItems: "center", marginTop: "20px" }}>
                        <div style={{ margin: "15px" }}>
                            <a href="https://www.michaeljfox.org/" target="_blank" style={{ cursor: "pointer" }}><img
                                src={foxLogo} width="225px" height="auto"/></a>
                        </div>
                        <div style={{ margin: "15px" }}>
                            <a href="https://us.movember.com/" target="_blank" style={{ cursor: "pointer" }}><img
                                src={movemberLogo} width="225px" height="auto"/></a>
                        </div>
                        <div style={{ margin: "15px" }}>
                            <a href="https://bornprimitive.com/" target="_blank" style={{ cursor: "pointer" }}><img
                                src={bornPrimitive} width="225px" height="auto"/></a>
                        </div>
                    </div>


                    <div className="flex-container-row"
                         style={{ justifyContent: "space-evenly", alignItems: "center", marginTop: "20px" }}>
                        <div>
                            <a href="https://www.athletewarriorgames.com/" target="_blank"
                               style={{ cursor: "pointer" }}><img src={awgLogo} width="175px" height="auto"/></a>
                        </div>
                        <div>
                            <a href="https://www.ultimateninja.net/" target="_blank" style={{ cursor: "pointer" }}><img
                                src={unaaLogo} width="175px" height="auto"/></a>
                        </div>
                        <div>
                            <a href="https://www.monstro.ninja/" target="_blank" style={{ cursor: "pointer" }}><img
                                src={monstroImg} width="175px" height="auto"/></a>
                        </div>
                        <div>
                            <a href="https://theninjapassport.com/" target="_blank" style={{ cursor: "pointer" }}><img
                                src={passportImg} width="175px" height="auto"/></a>
                        </div>
                    </div>

                </div>
                <UNXFooter title='' link='' linkTitle=''></UNXFooter>
            </div>
        );
    }
}


export default AboutUs;
